import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {  Functions, httpsCallableData } from '@angular/fire/functions';
import { StripeService, StripeCardComponent, StripeCardNumberComponent } from 'ngx-stripe';
import * as moment from 'moment-timezone';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  PaymentIntent,
} from '@stripe/stripe-js';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingComponent } from '../loading/loading.component';
import { User } from 'src/app/core/models/user';
import { Booking } from 'src/app/core/models/booking.model';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-stripe',
  templateUrl: 'stripe.component.html',
  styleUrls: ['stripe.component.scss']
})
export class StripeComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild(StripeCardNumberComponent) card: StripeCardNumberComponent;

  @Input()
  amount: Number;

  @Input()
  adjustedAmountForStripe: number;

  @Input()
  instructor: User;

  @Input()
  selectedBooking: Booking;

  @Input()
  studentTimezone: string;

  bookingDate: string;

  @Input()
  resetTimer: boolean;

  @Output()
  paymentCountDownEnded = new EventEmitter<Booking>();

  @Output()
  paymentEvent = new EventEmitter<boolean>();
  dialogRef: MatDialogRef<any, any>;

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#00bcd4',
        color: '#00bcd4',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }
  };

  countDownEnded(event) {
    this.paymentCountDownEnded.emit(this.selectedBooking);
  }

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  formSubmitted = false;
  stripeForm: FormGroup;

  constructor(private fb: FormBuilder, private stripeService: StripeService, private fns: Functions, private dialog: MatDialog,private spinner: NgxSpinnerService,) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    const date = moment(this.selectedBooking?.startDateTime)
    this.bookingDate = date.tz(this.studentTimezone).format('MMM d, yyyy @h:mm a z');
  }

  ngOnDestroy(): void {
    if (this.dialogRef !== undefined) {
      this.dialogRef.close();
    }
  }

  ngOnInit(): void {
    console.log('reset timer ', this.resetTimer)
    this.stripeForm = this.fb.group({
      name: ['', [Validators.required]],
    });
    console.log(this.amount, ' ', this.instructor, ' ', this.selectedBooking);
  }

  pay(): void {
    if (this.stripeForm.valid && !this.formSubmitted) {
      this.formSubmitted = true;
      this.spinner.show("bookingSpinner");
      this.createPaymentIntent()
        .pipe(
          switchMap((pi) =>
            this.stripeService.confirmCardPayment(pi.clientSecret, {
              payment_method: {
                card: this.card.element,
                billing_details: {
                  name: this.stripeForm.get('name').value,
                },
              },
            })
          )
        )
        .subscribe((result) => {
          if (result.error) {
            // Show error to your customer (e.g., insufficient funds)
            console.log(result.error.message);
            this.closeLoading();
            this.formSubmitted = false;
            this.paymentEvent.emit(false);
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
              //  alert('YES');
              console.log('PAYMENT SUCCESS');
              this.closeLoading();
              this.paymentEvent.emit(true);
            }
          }
        });
    } else {
      console.log(this.stripeForm);
    }
  }

  createPaymentIntent(): Observable<any> {
    const callable = httpsCallableData(this.fns,'stripe-createStipePaymentIntent');
    return callable({ amount: this.adjustedAmountForStripe });
  }

  openLoading(): void {
    this.dialogRef = this.dialog.open(LoadingComponent, { disableClose: true });
  }

  closeLoading(): void {
    if (this.dialog !== undefined) {
      this.dialog.closeAll();
    }
  }
}
